
import * as actionTypes from './actionType';

export const selectPrivacy = (privacyID) => { return {type: actionTypes.SET_PRIVACY, 'currentPrivacyID': privacyID} }
